import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type MissionVisionState = { thumbnailUrl?: string; title?: string; subTitle?: string; content?: string };

const initialState: MissionVisionState = {
};
export const aboutSlice = createSlice({
    name: "mission-vision",
    initialState,
    reducers: {
        missionVisionUpdate: (
            state,
            action: PayloadAction<MissionVisionState>
        ) => {
            state.title = action.payload.title;
            state.subTitle = action.payload.subTitle;
            state.thumbnailUrl = action.payload.thumbnailUrl;
            state.content = action.payload.content;
        }
    },
});

export const { missionVisionUpdate } = aboutSlice.actions;
export default aboutSlice.reducer;
